module.exports = __webpack_public_path__ + "static/img/OM@3x.f6ef0962.jpg";